import { Injectable, ErrorHandler } from '@angular/core';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
    handleError(error: any): void {

        // These happen when we release a new version of the app :()
        if (error instanceof Error && error.message) {
            if (error.message.includes('Failed to fetch dynamically imported module') || (error.message.includes('error loading dynamically imported module')) ||
            error.message.includes('Importing a module script failed')) {
                window.location.reload();
                return;
            }
            if (error.message.includes('The operation was aborted')) {
                // don't care about this error, just means they clicked off of it like a video or something
                return;
            }
            // these 2 errors are a bug in the oauth provider, it is nothing.
            if (error.message.includes('Validating access_token failed, wrong state/nonce.') || error.message.includes('Right side of assignment cannot be destructured')) {
                return;
            }
            if (error.message.includes('\'text/html\' is not'))
            {
                // this seems to happen sometimes when we release a new version
                window.location.reload();
                return;
            }
            if (error.message.includes('AbortError')) {
                // this just means they navigated away, not an issue
                return;
            }

        }

        // Anything we didn't recognise above is a real bug - don't swallow it.
        console.error(error);
    }
}